import ISO6391 from "iso-639-1";

export const toLocaleNumber = (value: string | number, lang: string) => {
  try {
    const code = ISO6391.getCode(lang);
    const floatVal = parseFloat(value.toString());
    const decimalLength = floatVal.toString().split(".")[1]?.length || 0;
    return floatVal.toLocaleString(code, {
      minimumFractionDigits: !decimalLength ? 0 : 2,
      maximumFractionDigits: !decimalLength ? 0 : 2,
    });
  } catch (e) {
    return value;
  }
};

// This method converts a number string to a raw number
// To allow , in number for languages like French, German, Italian, and Spanish
// IMP: When adding new languages, ensure to handle the number format correctly
export const toRawNumber = (number: string | number, lang: string) => {
  const numberStr = number.toString();
  try {
    switch (lang.toLowerCase()) {
      case "french":
      case "german":
      case "italian":
      case "spanish":
        return numberStr.replace(/,/g, ".");
      default:
        return numberStr;
    }
  } catch (e) {
    return numberStr;
  }
};

export const getValidDecimalSeparator = (lang: string) => {
  try {
    switch (lang.toLowerCase()) {
      case "french":
      case "german":
      case "italian":
      case "spanish":
        return ",";
      default:
        return ".";
    }
  } catch (e) {
    console.error("Error in getValidDecimalSeparator", e);
    return ".";
  }
};
